import { takeLatest, select, putResolve, put } from 'redux-saga/effects';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import { updateChoiceSuccess, updateChoices } from '@gcc/configurator/dist/actions/choiceActions';
import { configuratorChoices } from '../selectors/configurator';
import {
  updateSelectedChoice,
  setOmsIdFromUrl,
  initGuidedOptionFilter,
  setSelections,
  setAvailableChoices
} from '../actions';
import { selectSelectedCarpetChoice } from '../selectors/pricing';
import {
  skuDataSelector,
  findConfiguratorChoiceBySkuSelector,
  selectOptionsAndChoicesByOmsId
} from '../selectors/skuDataSelectors';
import { findTaggedValue } from '../utils/tags';
import safeSaga from './safeSaga';

const omsIdPattern = /[0-9]{9}/;

function* selectCarpetByOmsId() {
  try {
    // Only run on client side
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const omsId = params.get('omsId') || params.get('omsid');
    const fromPlpOrPip = omsIdPattern.test(omsId);

    if (fromPlpOrPip) {
      const selectedChoice = yield select(selectSelectedCarpetChoice);
      const configChoices = yield select(configuratorChoices);
      const skuData = yield select(skuDataSelector);
      // this assumes that all of the initial selections are valid......
      const isSuperSkuExperience = !isEmpty(skuData);
      if (isSuperSkuExperience) {
        const { optionId, choiceId } = yield select(findConfiguratorChoiceBySkuSelector(omsId));
        const selections = yield select(selectOptionsAndChoicesByOmsId(omsId));
        /* update choices for GCC Configurator selections */
        yield putResolve(updateChoices(Object.values(selections)));
        /* update choices for Single-Sale-Services selections */
        yield putResolve(setOmsIdFromUrl(choiceId));
        yield putResolve(setSelections(selections));
        yield putResolve(updateSelectedChoice({ id: choiceId, sku: omsId }));
        yield putResolve(setAvailableChoices());
      } else {
        // hacky but faster
        if (isEmpty(selectedChoice)) {
          const carpetChoiceFoundForOmsId = find(configChoices, (ch) => ch.tags.includes(`sku:${omsId}`));
          const carpetType = findTaggedValue(carpetChoiceFoundForOmsId.tags, 'carpettype');
          const colorFamily = findTaggedValue(carpetChoiceFoundForOmsId.tags, 'colorfamily');
          const carpetTypeChoice =
            find(configChoices, (ch) => ch.tags.includes(`carpettype:${carpetType}`) && ch.tags.length === 1);
          const colorFamilyChoice =
            find(configChoices, (ch) => ch.tags.includes(`color:${colorFamily.toLowerCase()}`) && ch.tags.length === 1);
          const colorFamilyValuesChoice = find(configChoices, (ch) => ch.tags.includes('multi-choice-values'));
          yield putResolve(updateSelectedChoice({ id: carpetChoiceFoundForOmsId.id }));
          yield putResolve(setOmsIdFromUrl(carpetChoiceFoundForOmsId.id));

          // updating carpet type choice and filtering carpet type
          const { optionId, id, value } = carpetTypeChoice;
          yield putResolve(updateChoiceSuccess(optionId, id, value));

          // updating color family choice, updating multi-select flag, and filtering color family
          configChoices[colorFamilyChoice.id].isMultiSelected = true;
          const { optionId: colorFamilyOptionId, id: colorFamilyId } = colorFamilyValuesChoice;
          yield putResolve(updateChoiceSuccess(colorFamilyOptionId, colorFamilyId, colorFamily));
          yield put(initGuidedOptionFilter({ type: 'carpetType', carpettype: carpetType }));
          yield put(initGuidedOptionFilter({ type: 'colorFamily', colorfamily: colorFamily }));
        }
        // More KLUDGE
        window.routeInfo.basePath = '/flooring';
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Check for carpet oms id saga failed: ${err.message}`);
  }
}

export function* checkForCarpetOmsIdSaga() {
  yield takeLatest('SAVE_UPDATED_CHOICES', safeSaga(selectCarpetByOmsId));
}
